.banner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: var(--color-easil-blue);
  z-index: 1000;
}

.bannerText {
  display: flex;
  align-items: center;
  max-width: 75%;
  width: 100%;
  color: white;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
  height: 46px;
}
